import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './store'
import { DetailsProvider } from 'features/Details/DetailsContext'
import { TemplateDetailsProvider } from 'features/TemplateDetails/TemplateDetailsContext'
import App from './components/App'
import Toaster from './components/ui/Toaster'
import { GlobalStyles } from './styles/globalStyles'
const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
	<Provider store={store}>
		<BrowserRouter>
			<GlobalStyles />
			<DetailsProvider>
				<TemplateDetailsProvider>
					<App />
				</TemplateDetailsProvider>
			</DetailsProvider>
			<Toaster />
		</BrowserRouter>
	</Provider>,
)
